<template>
  <tr :class="classes" class="table-row">
    <slot>
      <th
        v-if="enableSelection"
        class="table-cell table-select first shrink"
        @mousedown.prevent="mousedownSelect"
        @mouseenter="mouseenterSelect"
        @click.stop.prevent
      >
        <ux-checkbox :value="selected"> </ux-checkbox>
      </th>
      <table-cell
        :key="`${column.path || column.key}-${index}-${column.type}-${column.renderer}`"
        @click.stop.prevent="clickCell(column)"
        :column="column"
        :row="row"
        v-for="(column, index) in columns"
      >
      </table-cell>
      <th
        v-if="enableActions"
        class="table-cell last shrink"
        @click.stop.prevent="clickActions(row)"
      >
        <ux-button size="xs" icon>
          <ux-icon icon="fa-ellipsis" />
        </ux-button>
      </th>
      <th v-else-if="hasCorner" class="table-cell last shrink"></th>
    </slot>
  </tr>
</template>
<script>
import TableCell from "./TableCell.vue";

export default {
  components: {
    TableCell,
  },
  props: {
    selected: {
      type: Boolean,
    },
    index: {
      type: Number,
    },
    row: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    enableActions: {
      type: Boolean,
      default() {
        return false;
      },
    },
    enableSelection: {
      type: Boolean,
      default() {
        return true;
      },
    },
    hasCorner: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  emits: [
    "click:cell",
    "click:row",
    "click:actions",
    "mousedown:select",
    "mouseenter:select",
  ],
  methods: {
    clickCell(column) {
      this.$emit("click:cell", { row: this.row, column });
      this.$emit("click:row", this.row);
    },
    clickActions(row) {
      this.$emit("click:actions", row);
    },
    mousedownSelect(event) {
      this.$emit("mousedown:select", this.row, this.index, event);
    },
    mouseenterSelect() {
      this.$emit("mouseenter:select", this.row, this.index);
    },
  },
  computed: {
    classes() {
      var array = [];

      if (this.selected) {
        array.push("selected");
      }

      if (this.row?.meta?.status === "inactive") {
        array.push("inactive");
      }

      return array;
    },
  },
};
</script>
<style scoped lang="scss">
tr.inactive {
  // opacity: 0.3;

  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: color-mix(
      in lab,
      var(--bg1),
      transparent
    ); //rgba(currentColor, 0.2);
    display: block;
    pointer-events: none;
  }
}
</style>
